/* global bodymovin */
window.addEventListener('load', () => {
    const lhsSection = document.querySelectorAll('.landing-hero-section');

    lhsSection.forEach(section => {
        const lhsbgAnim = section.querySelector('.bg-animation-json');
        if (!lhsbgAnim) { return; }

        const dataJson = lhsbgAnim.getAttribute('data-json');
        let animationLoaded = false;

        function loadlhsbgAnim(elem, jsonPath) {
            const animate = bodymovin.loadAnimation({
                container: elem,
                path: jsonPath,
                renderer: 'svg',
                loop: false,
                autoplay: true,
            });
            animate.setSpeed(1.5);
        }

        // If the element is already visible (e.g. top of page), AOS might already have added the class
        if (lhsbgAnim.classList.contains('aos-animate') && !animationLoaded) {
            loadlhsbgAnim(lhsbgAnim, dataJson);
            animationLoaded = true;
            return;
        }

        // Watch for class changes (when aos-animate gets added)
        const observer = new MutationObserver(() => {
            if (lhsbgAnim.classList.contains('aos-animate') && !animationLoaded) {
                loadlhsbgAnim(lhsbgAnim, dataJson);
                animationLoaded = true;
                observer.disconnect(); // Stop watching
            }
        });

        observer.observe(lhsbgAnim, {
            attributes: true,
            attributeFilter: ['class'],
        });
    });
});
